import { FC, useEffect } from 'react';
import { useNavigate } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { SearchItem } from './search-item';
import { $SearchSugData } from 'shared/atoms';
import { SearchSugItem, SugType } from 'shared/models';
import { kepQueryFormat } from 'shared/utils';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { ClickPosition } from '~/utils/click-position';

import './style.scss';

export const SearchResult: FC<{ query: string }> = ({ query }) => {
  const { region } = useAtomValue($Locale);
  const sugList = useAtomValue($SearchSugData);

  const navigate = useNavigate();

  const onClick = (item?: SearchSugItem): void => {
    // only two type page, user or discover
    const isUserPage = item?.type === SugType.user;

    let url = '';
    if (isUserPage && item?.userId) {
      url = `/user/${item.userId}/share?pid=website_seo_from_sug`;
    } else if (item?.text) {
      url = `/discover/${kepQueryFormat(item.text)}?region=${region}&pid=website_seo_from_sug`;
    } else {
      return;
    }

    window.Tea('wap_click', {
      current_position: ClickPosition.search_sug_item,
      query: item?.userId || item.text,
      rank: item.rank || -1, // is enter key down, not real click
    });

    navigate(url);
  };

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent): void => {
      if (e.keyCode === 13 && query) {
        e.preventDefault();

        onClick({ text: query } as SearchSugItem);
      }
    };

    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [query]);

  return (
    <div className="wap-search-sug">
      {sugList.map((item) => (
        <SearchItem item={item} key={item.id} onClick={onClick} />
      ))}
    </div>
  );
};
